// extracted by mini-css-extract-plugin
export default {"main":"NeuroCourse_main__lAxRU"};